import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image"
import { IGatsbyFile } from './gatsbyTypes';

interface Props {
    file: IGatsbyFile
    title: string
    altText: string
    style?: object
    imgStyle?: object
}

export const SharpImage = ({ file, title, altText, style, imgStyle }: Props) => {

    if ( !file.childImageSharp)
        console.warn("Missing sharp image for post '" + title + "' image is '" + file.publicURL + "'")

    return (
        <>
            {file.childImageSharp && (
                <GatsbyImage image={file.childImageSharp.gatsbyImageData} title={title} alt={altText || title} imgStyle={imgStyle} style={style}/>
            )}
            {!file.childImageSharp && file.publicURL && (
                <img src={file.publicURL} title={title} alt={altText || title} />
            )}
        </>
    )
};

export default SharpImage;